/*eslint-disable*/
import React, {useState, useEffect, Fragment} from "react";

import APIClient from "../client";
import config from "../config.js"
import TableChart from "../components/Charts/TableChart.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";
import MapEditPopUp from "../components/Modals/MapEditModal";


const client = new APIClient(config);


export default function AdminOpportunityMap() {

    const [data, setData] = useState(null);
    const [mapData, setMapData] = useState(null);
    const [columnData, setColumnData] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchMapList();
    }, []);

    const fetchMapList = () => {
        client.getAllMapDisplays().then((data) => {
            setLoading(false);
            setData(data['data']['data']);
            const columns = [
                {
                    key: "action",
                    text: "Action",
                    className: "action",
                    width: 100,
                    align: "left",
                    sortable: false,
                    cell: (record) => {
                        return (
                            <Fragment>
                                <button
                                    className="get-started text-blue rounded py-1 px-7 bg-yellow"
                                    onClick={() => {
                                        setOpenEdit(true);
                                        setMapData(record);
                                    }}
                                >
                                    &nbsp;
                                    <i className="fa fa-pencil" aria-hidden="true"></i>
                                    &nbsp; Edit &nbsp;
                                </button>
                            </Fragment>
                        );
                    },
                },
                {
                    name: "id",
                    selector: (row) => row.id,
                },
                {
                    name: "map_id",
                    selector: (row) => row.map_id,

                },
                {
                    name: "iso3",
                    selector: (row) => row.iso3,
                },
                {
                    name: "name",
                    selector: (row) => row.name,
                },
                {
                    name: "value",
                    selector: (row) => row.value,
                },
                {
                    name: "available",
                    selector: (row) => row.available.toString(),
                },
            ];

            setColumnData(columns);
            setError(null);
        });
    };

    const closeModal = () => {
        setOpenEdit(false);
    };

    const handleSave = (updatedData) => {
        try {
            client.updateAvailableMapDisplays(updatedData)
                .then(() => {
                    fetchMapList();
                    closeModal();
                })
                .catch((err) => {
                    // setEditErrorMessage(err);
                    closeModal();
                });
        }
        catch (error) {
            console.log('Failed to submit map:', error);
        }
  };

    const ExpandedComponent = ({ data }) => <pre>{JSON.stringify(data, null, 2)}</pre>;
    const screenSize = (window.innerWidth >= 912);
    const screenSizeTwo = (window.innerWidth >= 1024);

    document.title = "Opportunity Admin";

    return (
        <>
            <section>
                <AuthNavbar />
            </section>

            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">

                    {loading && (
                        <div className="text-xl font-medium">Loading...</div>
                    )}
                    {error && <CardError message={error}/>}

                    {data && (

                        <>
                            <h2 className="text-36 text-yellow mb-6">Opportunity Map</h2>

                            <TableChart
                                columns={columnData}
                                data={data}
                                defaultSortFieldId={1}
                                expandableRows
                                expandableRowsComponent={ExpandedComponent}
                                dense
                            />

                        </>


                    )}

                </div>
                <MapEditPopUp objectData={mapData} isOpen={openEdit} onClose={closeModal} onSave={handleSave} />
            </section>


        </>
    );
}
